const language = {
    'pt':
    {
        add_new: 'Adicionar Nova Convocatória',
        add_new_jogo: 'Adicionar Novo Jogo',
        add_solution: 'Adicionar Convocatória',
        adicionar_departamento: 'Adicionar Departamento',
        adicionar_entidade: 'Adicionar Responsáveis',
        adicionar_jogador: 'Adicionar jogador',
        adicionar_linha: 'Adicionar linha',
        adicionar_projeto: 'Projetos de Software',
        agentes_desportivos: 'Agentes Desportivos',
        arbitro: 'Árbitro',
        area_placeholder: 'Selecione a sua area',
        assistencia: 'Assistência de Software',
        assistencia_botao: 'Adicionar pedido de assistência',
        assistencia_projeto: 'Adicionar Projetos',
        associar_cancel: 'Cancelar',
        associar_confirm: 'Inscrever',
        assunto: 'Assunto',
        atletas_inscritos: 'Atletas Inscritos',
        back: 'Voltar',
        birthday: 'Data de nascimento',
        cancel: 'Cancelar',
        city: 'Cidade',
        city_placeholder: 'Introduza a cidade',
        classificacao: 'Classificação',
        classificacao_placeholder: 'Posição / pontos',
        classificacoes: 'Classificações',
        cliente: 'Cliente',
        cliente_placeholder: 'Selecione o Cliente',
        close: 'Fechar',
        clube: 'Clube',
        clubes_inscritos: 'Clubes Inscritos',
        competicao: 'Convocatória',
        competicao_associada: 'Competição',
        competicao_evento: '2) Competição',
        competicao_list: 'Lista de Convocatórias',
        competicao_placeholder: 'Nome da competição',
        config: 'Configuração',
        consultar: 'Consultar',
        content: 'Conteúdo',
        content_edit: 'Editar conteúdo',
        content_list: 'Lista de conteúdos',
        content_new: 'Novo conteúdo',
        convocatoria: 'Convocatória',
        convocatoria_placeholder: 'Nome da convocatória',
        country: 'País',
        country_placeholder: 'Introduza o país',
        dados_competicao: 'Dados da Convocatória',
        dados_convocatoria: 'Dados da Convocatória',
        dark_mode: 'Dark mode',
        data: 'Data de Publicação',
        data_chegada_competicao: 'Data de chegada competição',
        data_chegada_estagio: 'Data de chegada estágio',
        data_disponivel: 'Disponível até',
        data_fim: 'Data e Hora de Fim:',
        data_inicio: 'Data e Hora de Início:',
        data_jogo: 'Data',
        data_saida: 'Data saída',
        date_creation: 'Criação',
        date_last_update: 'Última actualização',
        date_publication: 'Publicação',
        dates: 'Datas',
        defesas_por_periodo: 'DEFESAS POR PERÍODO',
        delete: 'Eliminar',
        delete_cancel: 'Não',
        delete_confirm: 'Sim',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_title: 'Eliminar Registo',
        departamento: 'Departamentos',
        departamento_data: 'Dados departamentais',
        departamento_placeholder: 'Dados de Departamento',
        description: 'Descrição',
        description_placeholder: 'Introduza uma descrição',
        dirigentes: 'Dirigentes',
        district: 'Distrito',
        district_placeholder: 'Introduza o distrito',
        doc_choose: 'Escolher ficheiro',
        edit: 'Editar',
        edit_cancel: 'Não',
        edit_confirm: 'Sim',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_title: 'Editar Registo',
        email: 'E-mail',
        email_placeholder: 'Introduza o e-mail',
        empresa: 'Empresa',
        empresa_placeholder: 'Introduza a Empresa',
        entity: 'Convocatórias',
        entity_edit: 'Editar Convocatória',
        entity_list: 'Listagem de Convocatórias',
        entity_new: 'Nova Convocatória',
        entity_type: 'Tipo de entidade',
        epoca: 'Época',
        eq_casa: 'EQ. DA CASA',
        eq_casa_curto: 'Eq. da Casa',
        eq_visitante: 'EQ. VISITANTE',
        eq_visitante_curto: 'Eq. Visitante',
        equipa_marcou: 'Equipa que Marcou',
        escalao: 'Escalão',
        escaloes: 'Escalão(ões)',
        escolher_jogador: 'Escolher jogador...',
        estagio: '1) Estágio',
        ficha_jogo: 'Ficha de Jogo',
        field_choose: 'Selecione',
		field_available: 'Disponível',
		field_activo: 'Inscrição',
        filter_concluido: 'Concluídos',
        filter_placeholder: 'Procurar',
        filter_resolver: 'Pedidos',
        fim: 'Fim',
        golos_por_periodo: 'GOLOS POR PERÍODO',
        hora_inicio: 'Hora Início',
        horario_golo: 'Horário do Golo',
        horario_maiusc: 'HORÁRIO',
        hours: 'horas',
        id: 'ID',
        identification_number: 'Número de identificação',
        identification_number_placeholder: 'Introduza o número de identificação',
        identification_validation: 'Validade',
        image: 'Imagem',
        image_choose: 'Escolher imagem',
        imediato: 'Imediato',
        infracao: 'Infração',
        inicio: 'Início',
        inscrever_agentes_desportivos: 'Inscrever Agente',
        inscrever_atleta_text: 'Confirma inscrever o atleta',
        inscrever_atleta_title: 'Inscrever atleta',
        inscrever_atletas: 'Inscrever Atletas',
        inscrever_clube: 'Inscrever Clube',
        inscrever_clube_text: 'Confirma inscrever o clube',
        inscrever_clube_text_2: 'nesta convocatória?',
        inscrever_clube_title: 'Inscrever clube',
        inscrever_dirigentes: 'Inscrever Dirigente',
        inscrever_pessoa_text: 'Confirma inscrever',
        inscrever_pessoa_title: 'Inscrever',
        inscrever_treinadores: 'Inscrever Treinador',
        insert_cancel: 'Não',
        insert_confirm: 'Sim',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_title: 'Novo Registo',
        jogo: 'Jogo',
        jogo_edit: 'Editar Jogo',
        jogo_list: 'Listagem de Jogos',
        jogo_new: 'Novo Jogo',
        jogos: 'Jogos',
        language: 'Lingua',
        licenca: 'Licença',
        licenca_placeholder: 'Introduza o Número da Licença',
        listagem_agentes: 'Listagem de Agentes Desportivos',
        listagem_dirigentes: 'Listagem de Dirigentes',
        listagem_treinadores: 'Listagem de Treinadores',
        loading: 'A carregar...',
        local: 'Localidade',
        local_competicao: 'Local da competição',
        local_data: 'Dados geográficos',
        local_estagio: 'Local do estágio',
        local_placeholder: 'Introduza a localidade',
        localidade_estagio: 'Localidade estágio',
        login_data: 'Dados de login',
        marcador: 'Marcador',
        mesa_jogo: 'Mesa de jogo',
        minutes: 'minutos',
        modalidade: 'Modalidade',
        modalidades: 'Modalidades',
        morada: 'Morada',
        morada_placeholder: 'Introduza a morada',
        name: 'Nome',
        no_projeto: 'Nome do Projeto Não Disponível',
        no_solution: 'Nenhuma solução adicionada',
        noFile: 'Sem ficheiro',
        nome_equipa: 'Nome da Equipa',
        nome_gr: 'Nome do G.R.',
        nome_jogadores: 'JOGADOR',
        not_found: 'Registo não encontrado.',
        numero: 'N.º',
        numero_atleta: 'Nº de Atleta',
        observacao: 'Observação',
        observacao_placeholder: 'Escreva algo',
        observacoes: 'Observações',
        pais_estagio: 'País estágio',
        paragem_tempo: 'Paragem de tempo:',
        password: 'Password',
        password_cancel: 'No',
        password_confirm: 'Continue',
        password_confirmation: 'Confirmação da Password',
        password_confirmation_placeholder: 'Confirme a password',
        password_error: 'Problem inserting element!',
        password_placeholder: 'Introduza a password',
        password_success: 'Successful inserted element!',
        password_text: 'As Passwords não correspondem.',
        password_title: 'Password!',
        penalidades_casa: 'PENALIDADES EQUIPA DA CASA',
        penalidades_visitante: 'PENALIDADES EQUIPA VISITANTE',
        per: 'Per.',
        periodo: 'Período',
        periodo_1: '1st',
        periodo_2: '2nd',
        periodo_3: '3rd',
        periodo_maiusc: 'PERÍODO',
        periodo_ot: 'OT',
        personal_data: 'Dados pessoais',
        pesquisar_atleta: 'Pesquisar Atleta',
        pesquisar_clube: 'Pesquisar Clube',
        pesquisar_entidade_placeholder: 'Pesquisar por nome...',
        pista: 'Pista',
        postal_code: 'Código-postal',
        postal_code_placeholder: 'Introduza o código-postal',
        primeiro_assist: '1º Assist.',
        principal: 'Principal',
        print: 'Imprimir',
        prioridade: 'Prioridade',
        profile: 'Perfil',
        projeto: 'Projetos',
        projeto_placeholder: 'Selecione o Projeto',
        regulamento: 'Regulamento',
        remove: 'Remover',
        remove_cancel: 'Cancelar',
        remove_confirm: 'Remover',
        remove_text: 'Confirma remover este registo da convocatória?',
        remove_title: 'Remover',
        respons: 'Responsável',
        responsavel: 'Responsáveis',
        responsavel_email: 'Email Responsável',
        responsavel_identificacao: 'Identi. Responsável',
        responsavel_placeholder: 'Selecione o Responsável',
        responsavel_telefone: 'Tel. Responsável',
        save: 'Salvar',
        scoring_ev: 'EV -',
        scoring_ev_desc: 'No tempo normal',
        scoring_key_titulo: 'Scoring Key',
        scoring_pp: 'PP -',
        scoring_pp_desc: 'Durante o tempo de penalidade da outra equipa',
        scoring_sh: 'SH -',
        scoring_sh_desc: 'Durante o tempo de penalidade da própria equipa',
        segundo_assist: '2º Assist.',
        selecionar_clube_hint: 'Selecione um clube na lista abaixo para gerir os atletas inscritos desse clube.',
        selecionar_treinador: 'Selecione o treinador',
        selecione_primeiro_epoca: 'Selecione primeiro a época',
        selecione_primeiro_equipa: 'Selecione primeiro a equipa',
        selecione_primeiro_modalidade: 'Selecione primeiro a modalidade',
        select: 'Selecione',
        sem_registos: 'Sem registos',
        software: 'Software',
        software_line: 'Linha de Software',
        software_line_placeholder: 'Introduza o Linha de Software',
        software_type: 'Tipo de Software',
        software_type_placeholder: 'Introduza o Tipo de Software',
        solucao: 'Solução',
        solucao_adicionadas: 'Soluções Adicionadas',
        table_actions: 'Acções',
        table_all: 'Todos',
        table_count: 'Count',
        table_date: 'Data',
        table_empty: 'Sem Resultados',
        table_parent: 'Parent',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_thumbnail: 'Thumbnail',
        table_title: 'Título',
        table_type: 'Tipo',
        tempo_penalidade: 'Tempo',
        temporada_label: 'Temporada',
        text: 'Texto',
        ticket_finish: 'Dar por Concluído o Ticket?',
        ticket_number: 'Nº',
        time: 'Tempo de Assistência',
        time_placeholder: 'Introduza o Tempo de Assistência',
        time_spent: 'Tempo Gasto',
        tipo_competicao: 'Tipo de Convocatória',
        tipo_convocatoria: 'Tipo de Convocatória',
        tipo_jogo: 'Tipo de Jogo',
        tipo_jogo_pdf: 'Conference, Non-Conference, or Playoff Game',
        title: 'Título',
        title_placeholder: 'Introduza o título',
        tlf: 'Telefone',
        tlf_placeholder: 'Introduza o número de telefone',
        tlm: 'Telemóvel',
        tlm_placeholder: 'Introduza o número de telemóvel',
        total: 'Total',
        total_golos_sofridos: 'Total de Golos Sofridos',
        total_min_jogados: 'Total de Min. Jogados',
        total_time_spent: 'Total de Tempo Gasto',
        treinador: 'TREINADOR',
        treinadores: 'Treinadores',
        type: 'Tipo de cliente',
        type_identification: 'Tipo de identificação',
        type_identification_placeholder: 'Introduza o tipo de identificação',
        type_placeholder: 'Introduza o tipo de cliente',
        upload_file_error: 'Formato do ficheiro incorrecto: ',
        username: 'Username',
        username_placeholder: 'Introduza o username',
        validade_identificacao: 'Validade da identificacao',
        vat: 'NIF',
        vat_placeholder: 'Introduza o NIF',
        village: 'Freguesia',
        village_placeholder: 'Introduza a freguesia',
        warning_cancel: 'Não',
        warning_confirm: 'Continuar',
        warning_error: 'Problema ao inserir registo!',
        warning_success: 'Registo inserido com sucesso!',
        warning_text: 'O username já existe no sistema.',
        warning_title: 'Aviso!',
    },

    'en':
    {
        add_new: 'Add New Call-up',
        add_new_jogo: 'Add New Game',
        add_solution: 'Add Call-up',
        add_test_solution: 'Add Test Solution',
        adicionar_departamento: 'Add Department',
        adicionar_entidade: 'Add Responsibles',
        adicionar_jogador: 'Add player',
        adicionar_linha: 'Add row',
        adicionar_projeto: 'Software Projects',
        agentes_desportivos: 'Sports Agents',
        arbitro: 'Official',
        area_placeholder: 'Select your area',
        assistencia: 'Software Assistance',
        assistencia_botao: 'Add Assistance Request',
        assistencia_projeto: 'Add Projects',
        associar_cancel: 'Cancel',
        associar_confirm: 'Register',
        assunto: 'Subject',
        atletas_inscritos: 'Registered Athletes',
        back: 'Back',
        birthday: 'Date of Birth',
        cancel: 'Cancel',
        city: 'City',
        city_placeholder: 'Enter the city',
        classificacao: 'Result',
        classificacao_placeholder: 'Position / points',
        classificacoes: 'Results',
        cliente: 'Client',
        cliente_placeholder: 'Select Client',
        close: 'Close',
        clube: 'Club',
        clubes_inscritos: 'Registered Clubs',
        competicao: 'Call-up',
        competicao_associada: 'Competition',
        competicao_evento: '2) Competition',
        competicao_list: 'Call-up List',
        competicao_placeholder: 'Competition name',
        config: 'Configuration',
        consultar: 'View',
        content: 'Content',
        content_edit: 'Edit Content',
        content_list: 'Content List',
        content_new: 'New Content',
        convocatoria: 'Call-up',
        convocatoria_placeholder: 'Call-up name',
        country: 'Country',
        country_placeholder: 'Enter the country',
        dados_competicao: 'Call-up Data',
        dados_convocatoria: 'Call-up Data',
        dark_mode: 'Dark mode',
        data: 'Publication Date',
        data_chegada_competicao: 'Competition arrival date',
        data_chegada_estagio: 'Training camp arrival date',
        data_disponivel: 'Available until',
        data_fim: 'End Date and Time:',
        data_inicio: 'Start Date and Time:',
        data_jogo: 'Date',
        data_saida: 'Departure date',
        date_creation: 'Creation',
        date_last_update: 'Last Update',
        date_publication: 'Publication',
        dates: 'Dates',
        defesas_por_periodo: 'SAVES BY PERIOD',
        delete: 'Delete',
        delete_cancel: 'No',
        delete_confirm: 'Yes',
        delete_error: 'Problem deleting record!',
        delete_success: 'Record deleted successfully!',
        delete_text: 'Are you sure you want to continue?',
        delete_title: 'Delete Record',
        departamento: 'Departments',
        departamento_data: 'Departmental Data',
        departamento_placeholder: 'Department Data',
        description: 'Description',
        description_placeholder: 'Enter a description',
        dirigentes: 'Officials',
        district: 'District',
        district_placeholder: 'Enter the district',
        doc_choose: 'Choose file',
        edit: 'Edit',
        edit_cancel: 'No',
        edit_confirm: 'Yes',
        edit_error: 'Problem updating record!',
        edit_success: 'Record updated successfully!',
        edit_text: 'Are you sure you want to continue?',
        edit_title: 'Edit Record',
        email: 'Email',
        email_placeholder: 'Enter the email',
        empresa: 'Company',
        empresa_placeholder: 'Enter the Company',
        entity: 'Call-ups',
        entity_edit: 'Edit Call-up',
        entity_list: 'Call-up Listing',
        entity_new: 'New Call-up',
        entity_type: 'Entity Type',
        epoca: 'Season',
        eq_casa: 'HOME',
        eq_casa_curto: 'HOME TEAM',
        eq_visitante: 'VISITORS',
        eq_visitante_curto: 'VISITING TEAM',
        equipa_marcou: 'Scoring Team',
        escalao: 'Age Group',
        escaloes: 'Age Group(s)',
        escolher_jogador: 'Choose player...',
        estagio: '1) Training Camp',
        ficha_jogo: 'Game Sheet',
        field_choose: 'Select',
		field_available: 'Disponível',
		field_activo: 'Inscrição',
        filter_concluido: 'Completed',
        filter_placeholder: 'Search',
        filter_resolver: 'Requests',
        fim: 'End',
        golos_por_periodo: 'SCORING BY PERIOD',
        hora_inicio: 'Game Time',
        horario_golo: 'Elapsed Time',
        horario_maiusc: 'TIME',
        hours: 'hours',
        id: 'ID',
        identification_number: 'Identification Number',
        identification_number_placeholder: 'Enter the identification number',
        identification_validation: 'Validity',
        image: 'Image',
        image_choose: 'Choose Image',
        imediato: 'Immediately',
        infracao: 'OFFENSE',
        inicio: 'Start',
        inscrever_agentes_desportivos: 'Register Agent',
        inscrever_atleta_text: 'Confirm registering the athlete',
        inscrever_atleta_title: 'Register athlete',
        inscrever_atletas: 'Register Athletes',
        inscrever_clube: 'Register Club',
        inscrever_clube_text: 'Confirm registering the club',
        inscrever_clube_text_2: 'in this call-up?',
        inscrever_clube_title: 'Register club',
        inscrever_dirigentes: 'Register Official',
        inscrever_pessoa_text: 'Confirm registering',
        inscrever_pessoa_title: 'Register',
        inscrever_treinadores: 'Register Coach',
        insert_cancel: 'No',
        insert_confirm: 'Yes',
        insert_error: 'Problem inserting record!',
        insert_success: 'Record inserted successfully!',
        insert_text: 'Are you sure you want to continue?',
        insert_title: 'New Record',
        jogo: 'Game',
        jogo_edit: 'Edit Game',
        jogo_list: 'Game Listing',
        jogo_new: 'New Game',
        jogos: 'Games',
        language: 'Language',
        licenca: 'License',
        licenca_placeholder: 'Enter the License Number',
        listagem_agentes: 'Sports Agents List',
        listagem_dirigentes: 'Officials List',
        listagem_treinadores: 'Coaches List',
        loading: 'Loading...',
        local: 'Location',
        local_competicao: 'Competition venue',
        local_data: 'Geographic Data',
        local_estagio: 'Training camp venue',
        local_placeholder: 'Enter the location',
        localidade_estagio: 'Training camp location',
        login_data: 'Login Data',
        marcador: 'Scorer',
        mesa_jogo: 'Scorer',
        minutes: 'minutes',
        modalidade: 'Discipline',
        modalidades: 'Disciplines',
        morada: 'Address',
        morada_placeholder: 'Enter the address',
        name: 'Name',
        no_projeto: 'No project added',
        no_solution: 'No solution added',
        noFile: 'No file',
        nome_equipa: 'Team Name',
        nome_gr: 'Goalie Name',
        nome_jogadores: 'PLAYER NAMES',
        not_found: 'Record not found.',
        numero: 'NO.',
        numero_atleta: 'Athlete No.',
        observacao: 'Observation',
        observacao_placeholder: 'Write something',
        observacoes: 'Notes',
        pais_estagio: 'Training camp country',
        paragem_tempo: 'TIME OUTS:',
        password: 'Password',
        password_cancel: 'No',
        password_confirm: 'Continue',
        password_confirmation: 'Password Confirmation',
        password_confirmation_placeholder: 'Confirm the password',
        password_error: 'Problem inserting element!',
        password_placeholder: 'Enter the password',
        password_success: 'Successful element insertion!',
        password_text: 'Passwords do not match.',
        password_title: 'Password!',
        penalidades_casa: 'HOME TEAM PENALTIES',
        penalidades_visitante: 'VISITING TEAM PENALTIES',
        per: 'PER.',
        periodo: 'Period',
        periodo_1: '1st',
        periodo_2: '2nd',
        periodo_3: '3rd',
        periodo_maiusc: 'PERIOD',
        periodo_ot: 'OT',
        personal_data: 'Personal Data',
        pesquisar_atleta: 'Search Athlete',
        pesquisar_clube: 'Search Club',
        pesquisar_entidade_placeholder: 'Search by name...',
        pista: 'Rink',
        postal_code: 'Postal Code',
        postal_code_placeholder: 'Enter the postal code',
        primeiro_assist: '1st assist',
        principal: 'Principal',
        print: 'Print',
        prioridade: 'Priority',
        profile: 'Profile',
        projeto: 'Projects',
        projeto_placeholder: 'Select Project',
        regulamento: 'Regulations',
        remove: 'Remove',
        remove_cancel: 'Cancel',
        remove_confirm: 'Remove',
        remove_text: 'Confirm removing this entry from the call-up?',
        remove_title: 'Remove',
        respons: 'Responsible',
        responsavel: 'Responsibles',
        responsavel_email: 'Responsible - Email',
        responsavel_identificacao: 'Responsible - Name',
        responsavel_placeholder: 'Select the Responsible',
        responsavel_telefone: 'Responsible - Phone',
        save: 'Save',
        scoring_ev: 'EV -',
        scoring_ev_desc: 'even',
        scoring_key_titulo: 'Scoring Key',
        scoring_pp: 'PP -',
        scoring_pp_desc: 'power play',
        scoring_sh: 'SH -',
        scoring_sh_desc: 'short handed',
        segundo_assist: '2nd assist',
        selecionar_clube_hint: 'Select a club from the list below to manage the athletes registered for that club.',
        selecionar_treinador: 'Select the coach',
        selecione_primeiro_epoca: 'Select the season first',
        selecione_primeiro_equipa: 'Select the team first',
        selecione_primeiro_modalidade: 'Select the discipline first',
        select: 'Select',
        sem_registos: 'No records',
        software: 'Software',
        software_line: 'Software Line',
        software_line_placeholder: 'Enter the Software Line',
        software_type: 'Software Type',
        software_type_placeholder: 'Enter the Software Type',
        solucao: 'Solution',
        solucao_adicionadas: 'Added Solutions',
        table_actions: 'Actions',
        table_all: 'All',
        table_count: 'Count',
        table_date: 'Date',
        table_empty: 'No Results',
        table_parent: 'Parent',
        table_rows_per_page: 'Records per page:',
        table_separator: 'of',
        table_state: 'State',
        table_thumbnail: 'Thumbnail',
        table_title: 'Title',
        table_type: 'Type',
        tempo_penalidade: 'TIME',
        temporada_label: 'Season',
        text: 'Text',
        ticket_finish: 'Mark Ticket as Completed?',
        ticket_number: 'No.',
        time: 'Assistance Time',
        time_placeholder: 'Enter the Assistance Time',
        time_spent: 'Time Spent',
        tipo_competicao: 'Call-up Type',
        tipo_convocatoria: 'Call-up Type',
        tipo_jogo: 'Game Type',
        tipo_jogo_pdf: 'Conference, Non-Conference, or Playoff Game',
        title: 'Title',
        title_placeholder: 'Enter the title',
        tlf: 'Phone',
        tlf_placeholder: 'Enter the phone number',
        tlm: 'Mobile',
        tlm_placeholder: 'Enter the mobile number',
        total: 'Total',
        total_golos_sofridos: 'Total Goals Allowed',
        total_min_jogados: 'Total Min. Played',
        total_time_spent: 'Total Time Spent',
        treinador: 'COACH',
        treinadores: 'Coaches',
        type: 'Customer Type',
        type_identification: 'Identification Type',
        type_identification_placeholder: 'Enter the identification type',
        type_placeholder: 'Enter the customer type',
        upload_file_error: 'Incorrect file format: ',
        username: 'Username',
        username_placeholder: 'Enter the username',
        validade_identificacao: 'Validity of identification',
        vat: 'VAT',
        vat_placeholder: 'Enter the VAT',
        village: 'Village',
        village_placeholder: 'Enter the village',
        warning_cancel: 'No',
        warning_confirm: 'Continue',
        warning_error: 'Problem inserting record!',
        warning_success: 'Record inserted successfully!',
        warning_text: 'The username already exists in the system.',
        warning_title: 'Warning!',
    },

    'es': {
    }
}

module.exports = {
    language
};